// @flow
/* eslint max-len:0 */

const isProd = process.env.NODE_ENV === 'production';

// consts to help URL constants be more readable and updatable.
const canonicalMainDomain = 'www.pinterest.com';
const canonicalMainUrl = 'https://' + canonicalMainDomain;
const newsroomRelativeUrl = '/_/_/newsroom/';
const newsroomUrl = canonicalMainUrl + newsroomRelativeUrl;
const policyRelativeUrl = '/_/_/policy/';
const policyUrl = canonicalMainUrl + policyRelativeUrl;

export default {
  settings: {
    SHOPPING_CATALOGS_URL: 'https://www.pinterest.com/product-catalogs',
    SHOPPING_CATALOGS_PRODUCT_GROUPS_URL:
      'https://www.pinterest.com/product-catalogs/product-groups/',
    PARTNER_CONVERT_ACCOUNT: '/business/convert/',
    HELP_RELATIVE_URL: '/_/_/help/',
    RELATIVE_PARTNER_SITE_URL: '/_/_/business/',
    HELP_PROMOTED_PINS_INTEREST_TARGETING_URL:
      'https://www.pinterest.com/_/_/help/business/article/interest-targeting',
    SIGNUP_URL: '/join/',
    HELP_BOARDS_INVITE_URL_SRC_CREATE:
      'https://www.pinterest.com/_/_/help/article/invite-friends-to-a-group-board?source=board_create',
    ABOUT_URL: 'https://www.pinterest.com/_/_/about/',
    HELP_BOARDS_SECRET_URL_SRC_PROFILE:
      'https://www.pinterest.com/_/_/help/article/change-board-privacy?source=profile',
    HELP_PROMOTED_PINS_CPC_BID_URL:
      'https://www.pinterest.com/_/_/help/business/article/create-ad-group',
    HELP_COMMON_BUSINESS_QUESTIONS_URL:
      'https://www.pinterest.com/_/_/help/articles/common-business-questions?qa=6',
    PASSWORD_RESET_URL: '/password/reset/',
    ADS_SITE_CONVERSION_TRACKING: 'https://ads.pinterest.com/conversion_tags/',
    ABOUT_PRIVACY_URL: 'https://www.pinterest.com/_/_/about/privacy/',
    ABOUT_COPYRIGHT_URL: 'https://www.pinterest.com/_/_/about/copyright/',
    ABOUT_MESSAGES_URL: 'https://www.pinterest.com/_/_/about/messages/',
    ABOUT_BUY_IT_URL: 'https://www.pinterest.com/_/_/about/buy-it/',
    ABOUT_GOODIES_URL: 'https://www.pinterest.com/_/_/about/goodies/',
    ABOUT_ETIQUETTE_URL: 'https://www.pinterest.com/_/_/about/basics/#etiquette',
    ABOUT_BASICS_URL: 'https://www.pinterest.com/_/_/about/basics/',
    ABOUT_PRESS_URL: 'https://www.pinterest.com/_/_/about/press/',
    ABOUT_TEAM_URL: 'https://www.pinterest.com/_/_/about/team/',
    ABOUT_USE_URL: 'https://www.pinterest.com/_/_/about/use/',
    ABOUT_TERMS_URL: 'https://www.pinterest.com/_/_/about/terms-service/',
    ABOUT_LENS_URL: 'https://www.pinterest.com/_/_/about/lens/',
    ABOUT_IMPRESSUM_URL: '/_/_/about/de/impressum/',
    CONFIRM_WEBSITE: '/website/confirm',
    PARTNER_SITE_SIGNUP: '/business/create/',
    PIN_ANALYTICS_LEARN_MORE_URL: 'https://www.pinterest.com/_/_/help/articles/pin-stats',
    CLAIM_YOUR_WEBSITE_LEARN_MORE_URL:
      'https://www.pinterest.com/_/_/help/articles/claim-your-website',
    RSS_AUTO_PUBLISH_LEARN_MORE_URL:
      'https://help.pinterest.com/business/article/auto-publish-pins-from-your-rss-feed',
    DEBUG: !isProd,
    HELP_WEBSITE_CONVERSION_TRACKING_URL:
      'https://www.pinterest.com/_/_/help/business/article/pinterest-tag-implementation-overview',
    HELP_PINTEREST_CRAWLER: 'https://www.pinterest.com/_/_/help/articles/about-pinterest-crawler-0',
    HELP_WEBSITE_CONVERSION_CAMPAIGNS:
      'https://www.pinterest.com/_/_/help/business/article/conversions-campaigns',
    HELP_WEBSITE_CONVERSION_TRACKING_EVENTS_URL:
      'https://www.pinterest.com/_/_/help/business/article/event-code',
    HELP_WEBSITE_CONVERSION_ENHANCED_MATCH_URL:
      'https://www.pinterest.com/_/_/help/business/article/enhanced-match',
    HELP_PROMOTED_PINS_LOOKALIKE_TARGETING_URL:
      'https://www.pinterest.com/_/_/help/articles/personalized-ads-pinterest',
    PARTNER_SITE_URL: 'https://www.pinterest.com/_/_/business/',
    BRANCH_UNAUTH_IOS_DESKTOP_UPSELL: 'https://bnc.lt/unauth-ios-upsell-desktop-web',
    PARTNER_SITE_SUPPORT_URL:
      'https://www.pinterest.com/_/_/help/business/topics/advertise-on-pinterest',
    AUDIENCE_INSIGHTS_SUPPORT_URL: 'https://www.pinterest.com/_/_/help/articles/audience-insights',
    ANALYTICS_SUPPORT_URL: 'https://www.pinterest.com/_/_/help/articles/pinterest-analytics',
    CLAIM_YOUR_ACCOUNTS_LEARN_MORE_URL:
      'https://www.pinterest.com/_/_/help/articles/claim-your-instagram-etsy-or-youtube-account',
    FACEBOOK_API_KEY: isProd ? '274266067164' : '360467581347',
    ADS_DOMAIN: 'ads.pinterest.com',
    ADS_SITE_URL: 'https://ads.pinterest.com',
    CANONICAL_MAIN_DOMAIN: 'www.pinterest.com',
    CANONICAL_HELP_CENTER_URL: 'https://help.pinterest.com',
    CANONICAL_MAIN_URL: 'https://www.pinterest.com',
    CANONICAL_POLICY_URL: 'https://policy.pinterest.com',
    CANONICAL_ADS_URL: 'https://ads.pinterest.com',
    CANONICAL_ANALYTICS_URL: 'https://analytics.pinterest.com',
    ADS_SITE_CPC_URL: 'https://ads.pinterest.com/traffic/',
    HELP_PIN_POLICIES_URL: 'https://www.pinterest.com/_/_/about/acceptable-use-policy/',
    RELATIVE_ABOUT_URL: '/_/_/about/',
    EXTENSION_PINIT_CHROME_URL:
      'https://chrome.google.com/webstore/detail/gpdjojdkbbmdfjfahjcgigfpmkopogic',
    HELP_BLOCKING: 'https://www.pinterest.com/_/_/help/articles/block-or-unblock-someone',
    PUBLIC_API_URL: 'https://api.pinterest.com',
    CONVERSION_TRACKING_DOMAIN: 'ct.pinterest.com',
    ABOUT_DMCA_PIN_URL: '/about/copyright/dmca-pin/',
    ABOUT_TRADEMARK_FORM: '/about/trademark/form/',
    AUTHENTICATION_ORIGIN: 'https://www.pinterest.com',
    TRUSTED_HOSTNAME_ENDING: 'pinterest.com',
    PINTERDEV_DOMAIN: 'pinterdev.com',
    GPLUS_CLIENT_ID: '694505692171-31closf3bcmlt59aeulg2j81ej68j6hk.apps.googleusercontent.com',
    HELP_URL: 'https://www.pinterest.com/_/_/help/',
    HELP_UNDERSTAND_PRIVACY:
      'https://www.pinterest.com/_/_/help/articles/change-your-privacy-settings',
    BUSINESS_SITE_URL: 'https://business.pinterest.com',
    FACEBOOK_CLIENT_ID: 1431633,
    GPLUS_SCOPE: 'profile email',
    REPORTED_CONTENT_PLACEHOLDER_URL: 'https://www.pinterest.com/pin/12345/',
    ABOUT_COOKIE_URL: 'https://www.pinterest.com/_/_/about/cookie-policy/',
    PARTNER_SITE_MAKE_GREAT_PINS_URL:
      'https://www.pinterest.com/_/_/business/creative-best-practices',
    LOGIN_URL: '/login/',
    LOGOUT_URL: '/logout/',
    ABOUT_ADVERTISING_STANDARDS_URL: '/_/_/about/advertising-standards/',
    HELP_WHY_BLOCKED_FOR_INAPPROPRIATE_URL: 'https://www.pinterest.com/_/_/help/entries/21436306',
    HELP_LOGIN_TROUBLES: 'https://www.pinterest.com/_/_/help/articles/login-trouble',
    HELP_PASSWORD_RESET_URL: 'https://www.pinterest.com/_/_/help/articles/trouble-pinterest-emails',
    PARTNER_SITE_ADS_SUPPORT_URL: 'https://help.pinterest.com/contact',
    ACCOUNT_SUSPENSION_APPEAL_URL:
      'https://help.pinterest.com/contact?current_page=about_you_page&appeals=account_suspension',
    DEVELOPER_DOC_CONVERSION_TAG_LINK:
      'https://developers.pinterest.com/docs/ad-tools/conversion-tag/',
    HELP_PROMOTED_PINS_BUYABLE_PIN:
      'https://www.pinterest.com/_/_/help/articles/selling-on-pinterest',
    HELP_COMMERCE_POLICY_URL: 'https://policy.pinterest.com/commerce-guidelines',
    RELATIVE_TERMS_URL: '/_/_/about/terms-service/',
    HELP_PERSONALIZATION_AND_DATA:
      'https://www.pinterest.com/_/_/help/articles/personalization-and-data',
    ADS_SITE_CREATE: 'https://ads.pinterest.com/promoted_pin_v2/campaign/',
    HELP_REPORT_PERSON_URL: 'https://www.pinterest.com/_/_/help/entries/22163668',
    COPYRIGHT_YEAR: '2019',
    HELP_SHOWCASE: 'https://www.pinterest.com/_/_/help/articles/showcase',
    HELP_PROMOTED_PINS_REJECTED_PIN_URL:
      'https://www.pinterest.com/_/_/help/articles/creating-and-editing-promoted-pins?qa=9',
    HELP_AUDIENCE_WEBSITE_URL: 'https://www.pinterest.com/_/_/help/articles/confirm-your-website',
    ANALYTICS_SITE_URL: 'https://analytics.pinterest.com',
    AUDIENCE_INSIGHTS_URL: 'https://analytics.pinterest.com/audience-insights/',
    ANALYTICS_MONTHLY_VIEWERS_URL:
      'https://analytics.pinterest.com/overview/?primary_metric=TOTAL_AUDIENCE',
    ANALYTICS_MONTHLY_ENGAGERS_URL:
      'https://analytics.pinterest.com/overview/?primary_metric=ENGAGERS',
    HELP_PROMOTED_PINS_BILLING_URL:
      'https://www.pinterest.com/_/_/help/articles/billing-and-payment',
    HELP_BILLING_ACCEPTED_PAYMENTS_URL:
      'https://www.pinterest.com/_/_/help/business/article/accepted-payments',
    HELP_PROMOTED_PINS_RETARGETED_PIN_URL:
      'https://www.pinterest.com/_/_/help/articles/personalized-ads-pinterest',
    PARTNER_SITE_BEST_PRACTICES_GUIDE_URL:
      'https://www.pinterest.com/_/_/business/using-ads-manager',
    ABOUT_PRIVACY_PLAIN_URL: '/_/_/about/privacy/',
    ABOUT_CAREERS_URL: 'https://careers.pinterest.com/',
    PARTNER_SITE_TOS_URL: 'https://www.pinterest.com/_/_/business/tos/',
    ADVERTISER_TOS_NA_URL:
      'https://business.pinterest.com/en/pinterest-advertising-services-agreement',
    ADVERTISER_TOS_FR_URL:
      'https://business.pinterest.com/fr/pinterest-advertising-services-agreement',
    ADVERTISER_TOS_ROW_URL:
      'https://business.pinterest.com/en-gb/pinterest-advertising-services-agreement',
    HELP_CENTER_URL: 'https://www.pinterest.com/_/_/help/',
    DEFAULT_HELP_URL: '//help.pinterest.com/',
    DEVELOPER_SITE_URL: 'https://developers.pinterest.com',
    HELP_ADS_BULK_EDITOR_URL: 'https://www.pinterest.com/_/_/help/articles/bulk-editor',
    HELP_ADS_CONVERSION_EXPORT_SAFARI11_URL:
      'https://www.pinterest.com/_/_/help/articles/bulk-editor',
    HELP_ADS_ONE_TAP_MIGRATION_URL: 'https://www.pinterest.com/_/_/help/articles/one-tap-migration',
    HELP_BOARDS_SECRET_URL_SRC_CREATE:
      'https://www.pinterest.com/_/_/help/article/change-board-privacy?source=secret_create',
    BRANCH_UNAUTH_ANDROID_DESKTOP_UPSELL: 'https://bnc.lt/unauth-android-upsell-desktop-web',
    HELP_PROMOTED_PINS_URL: 'https://www.pinterest.com/_/_/help/articles/promoted-pins',
    ABOUT_TERMS_PLAIN_URL: '/_/_/about/terms-service/',
    HELP_AD_GROUPS_SETUP_URL: 'https://www.pinterest.com/_/_/help/articles/ad-groups/?qa=3',
    POLICY_ADS_GUIDELINES: 'https://policy.pinterest.com/advertising-guidelines',
    POLICY_ADS_GUIDELINES_DATA_USAGE:
      'https://policy.pinterest.com/advertising-guidelines#section-be-careful-with-any-data-usage',
    POLICY_ADS_GUIDELINES_PROHIBITED_PRODUCTS:
      'https://policy.pinterest.com/advertising-guidelines#section-prohibited-content-guidelines',
    POLICY_ADS_DATA_TERMS: 'https://policy.pinterest.com/ad-data-terms',
    POLICY_ADS_TARGETING_GUIDELINES:
      'https://policy.pinterest.com/advertising-guidelines#section-be-respectful-with-your-targeting',
    // URL does not contain "en" or "_" intentionally
    // see https://pinterest.slack.com/archives/C04RREZ9Z/p1554421359012100
    POLICY_COMMUNITY_GUIDELINES: 'https://policy.pinterest.com/community-guidelines',
    POLICY_COMMUNITY_GUIDELINES_SAFETY:
      'https://policy.pinterest.com/community-guidelines#section-safety',
    POLICY_COMMUNITY_GUIDELINES_SPAM_AND_QUALITY:
      'https://policy.pinterest.com/community-guidelines#section-spam-and-quality',
    CORS_HANDSHAKE_DOMAINS: [
      'https://www.pinterest.info',
      'https://www.pinterest.at',
      'https://www.pinterest.com.au',
      'https://www.pinterest.ca',
      'https://www.pinterest.ch',
      'https://www.pinterest.cl',
      'https://www.pinterest.de',
      'https://www.pinterest.dk',
      'https://www.pinterest.es',
      'https://www.pinterest.fr',
      'https://www.pinterest.co.uk',
      'https://www.pinterest.ie',
      'https://www.pinterest.it',
      'https://www.pinterest.jp',
      'https://www.pinterest.co.kr',
      'https://www.pinterest.com.mx',
      'https://www.pinterest.nz',
      'https://www.pinterest.se',
      'https://www.pinterest.com.pe',
      'https://www.pinterest.ph',
      'https://www.pinterest.pt',
      'https://www.pinterest.com.py',
      'https://www.pinterest.ru',
      'https://www.pinterest.com.uy',
    ],
    ABOUT_BROWSER_BUTTON_URL: '/_/_/about/browser-button/',
    ABOUT_GUIDED_SEARCH_URL: '/_/_/about/guidedsearch/',
    ABOUT_ACCEPTABLE_USE: 'https://www.pinterest.com/_/_/about/acceptable-use-policy/',
    HELP_PROMOTED_PINS_APP_INSTALL_URL:
      'https://www.pinterest.com/_/_/help/articles/promote-app-install-pins',
    PARTNER_PROPEL_BLOG_POST:
      'https://www.pinterest.com/_/_/business/blog/introducing-pinterest-propel-for-successful-advertising',
    PARTNER_SITE_HOW_TO: 'https://www.pinterest.com/_/_/business/how-pinterest-works',
    EU_COUNTRIES: [
      'AT',
      'BE',
      'BG',
      'HR',
      'CH',
      'CY',
      'CZ',
      'DK',
      'EE',
      'FI',
      'FR',
      'DE',
      'GB',
      'GR',
      'HU',
      'IE',
      'IT',
      'LV',
      'LT',
      'LU',
      'MT',
      'NL',
      'PL',
      'PT',
      'RO',
      'SK',
      'SI',
      'ES',
      'SE',
    ],
    MINIMUM_AGE_BY_EU_COUNTRY: {
      /* GDPR EU mapping - KEEP CONSISTENT WITH settings/base.py */
      AT: 14,
      BE: 13,
      BG: 16,
      HR: 16,
      CY: 14,
      CZ: 15,
      DK: 13,
      EE: 14,
      FI: 13,
      FR: 15,
      DE: 16,
      GR: 15,
      HU: 16,
      IE: 16,
      IT: 14,
      LV: 13,
      LT: 14,
      LU: 16,
      MT: 13,
      NL: 16,
      PL: 16,
      PT: 13,
      RO: 16,
      SK: 16,
      SI: 15,
      ES: 14,
      SE: 13,
      GB: 13,
    },
    EN_COUNTRIES_WITH_MANDATORY_AGE: ['US', 'CA', 'NZ', 'AU'],
    ACCOUNTS_PINTEREST_URL: 'https://accounts.pinterest.com',
    GPLUS_APP_PACKAGE_NAME: 'com.pinterest',
    HELP_CONTACT_URL: 'https://www.pinterest.com/_/_/help/contact',
    API_MAX_PAGE_SIZE: 250,
    BLOG_URL: 'https://www.pinterest.com/_/_/blog/',
    HELP_PROMOTED_PINS_AUDIENCE_TARGETING_URL:
      'https://www.pinterest.com/_/_/help/articles/targeting?qa=4',
    HELP_CAMPAIGN_CREATION_ONE_TAP_URL:
      'https://www.pinterest.com/_/_/help/articles/creating-and-editing-promoted-pins?qa=3',
    HELP_AD_GROUP_CREATION_URL:
      'https://www.pinterest.com/_/_/help/business/article/create-ad-group',
    HELP_AD_GROUP_EXPANDED_TARGET_URL: 'https://www.pinterest.com/_/_/help/articles/targeting?qa=5',
    HELP_PROMOTED_PINS_ARCHIVING:
      'https://www.pinterest.com/_/_/help/articles/promoted-pin-tips?qa=6',
    PERSONALIZED_ADS_URL: 'https://www.pinterest.com/_/_/help/articles/personalized-ads-pinterest',
    HELP_AD_DELIVERY_URL: 'https://www.pinterest.com/_/_/help/business/article/create-ad-group',
    PINTEREST_TAG_HELPER_EXTENSION_CHROME_WEBSTORE_URL:
      'https://chrome.google.com/webstore/detail/pinterest-tag-helper/gmlcbajhgoaaegmlbaclmmmhpmfdajmp',
    HELP_GDPR_CHILD_POLICY_URL:
      'https://www.pinterest.com/_/_/help/articles/age-requirements-using-pinterest',
    SSIO_TERMS_LEARN_MORE_URL:
      'https://www.pinterest.com/_/_/business/pinterest-advertising-services-agreement',
    SSIO_ORDER_MANAGEMENT_EMAIL: 'ordermanagement@pinterest.com',
    PARTNER_PRODUCT_SPECS_URL: 'https://www.pinterest.com/_/_/business/Pinterest-product-specs',
    STORY_PINS_SPEC_URL: 'https://www.pinterest.com/_/_/help/business/article/story-pins',
    HELP_BUILD_PIN_URL: 'https://www.pinterest.com/_/_/help/business/article/build-a-pin',
    HELP_PICK_PINS_TO_PROMOTE: 'https://help.pinterest.com/business/article/pick-pins-to-promote',
    PIN_PRIVACY: {
      SECRET: 'secret',
      PUBLIC: 'public',
      PROTECTED: 'protected',
    },
    ANALYTICS_OVERVIEW_IS_DEFAULT_KEY: 'analyticsOverviewIsDefault',
    HELP_KEYWORD_TARGETING_URL:
      'https://www.pinterest.com/_/_/help/business/article/keyword-targeting',
    HELP_LOCATION_TARGETING_URL:
      'https://www.pinterest.com/_/_/help/business/article/location-language-device-and-gender-targeting',
    HELP_PLANNING_MOMENTS_TARGETING_URL:
      'https://help.pinterest.com/en/business/article/planning-moments',
    ENGAGEMENT_URL: '/engagement/',
    HELP_PROMOTED_APP_PINS_URL:
      'https://www.pinterest.com/_/_/help/business/article/promoted-app-pins',
    HELP_AD_BIDDING_URL: 'https://help.pinterest.com/en/business/article/set-your-bid',
    HELP_ADS_USE_BULK_EDITOR_URL:
      'https://www.pinterest.com/_/_/help/business/article/use-the-bulk-editor',
    BOOKMARKLET_LOGGING_URL: 'https://log.pinterest.com/',
    APPS_LEARN_MORE: 'https://pinterest.com/_/_/help/article/connect-to-other-apps-with-pinterest',
    SECURITY_TWO_FACTOR_LEARN_MORE: 'https://pinterest.com/_/_/help/article/see-recent-logins',
    SEARCH_PRIVACY: 'https://pinterest.com/_/_/help/article/update-your-search-privacy',
    PRIVACY_AND_DATA: 'https://pinterest.com/_/_/help/article/personalization-and-data#info-ad',
    THIRD_PARTY_ADVERTISING_PRIVACY:
      'https://help.pinterest.com/en/article/third-party-analytics-or-advertising-providers-pinterest-uses-or-allows',
    PARTNER_PROFILE:
      'https://pinterest.com/_/_/help/business/article/feature-boards-on-your-profile',
    LOGIN_LEARN_MORE:
      'https://pinterest.com/_/_/help/article/link-your-social-media?source=settings_page',
    EDIT_PROFILE_URL: 'www.pinterest.com/',
    MERGE_ACCOUNTS: 'https://pinterest.com/_/_/help/article/merge-accounts',
    HELP_ABOUT_CATALOGS: 'https://help.pinterest.com/business/article/about-catalogs',
    HELP_CATALOGS_DATA_SOURCE_SETUP:
      'https://help.pinterest.com/business/article/data-source-setup',
    HELP_CATALOGS_DATA_SOURCE_ERROR_MESSAGES:
      'https://help.pinterest.com/business/article/catalog-data-source-error-messages',
    HELP_CATALOGS_CREATE_PRODUCT_GROUPS:
      'https://help.pinterest.com/business/article/create-product-groups',
    HELP_SHOPPING_ADS_OVERVIEW:
      'https://www.pinterest.com/_/_/help/business/article/shopping-ads-overview',
    HELP_SHOPPING_ADS: 'https://help.pinterest.com/business/article/shopping-ads',
    POLICY_MERCHANT_GUIDELINES: 'https://policy.pinterest.com/merchant-guidelines',
    SHOPPING_BUSINESS_BLOG: 'https://business.pinterest.com/shopping-on-Pinterest',
    HELP_CENTER_REQUEST_A_FEATURE: 'https://pinterest.com/_/_/help/landing/request-a-feature',
    HELP_AD_BILLING_VAT: 'https://pinterest.com/_/_/help/business/article/vat/',
    HOMEFEED: '/homefeed/',
    HELP_VIDEO_PINS: 'https://www.pinterest.com/_/_/help/business/article/video-pins',
    IOS_APPSTORE_ID: '429047995',
    GOOGLEPLAY_ID: 'com.pinterest',
    PINTEREST_DOWNLOAD_ITUNES_STORE_URL: 'http://itunes.com/apps/Pinterest/',
    WINDOWS_STORE_URL: 'ms-windows-store://pdp/?productid=9PFHDSF91B9R',
    DEFAULT_NEWSROOM_URL: newsroomUrl,
    DEFAULT_POLICY_URL: policyUrl,
  },
};
